// third-party
import { createSlice } from '@reduxjs/toolkit';
import TournamentDto from 'common/dto-types/tournament-dto';
import { PaginationParam, SortingParam, SortingType } from 'components/base-table/dto';
import { DefaultVisibleContactColumns } from 'pages/contact/contact-column-config';
import { Filters } from 'react-table';

type ContactSliceStates = {
    filters: Filters<any>;
    tournamentFilter: TournamentDto | null;
    sorting: SortingParam;
    pagination: PaginationParam;
    visibleColumns: Array<string>;
};

const initialState: ContactSliceStates = {
    filters: [],
    tournamentFilter: null,
    sorting: { sortingType: SortingType.Ascending, sortBy: 'firstName', searchTerm: '' },
    pagination: { pageSize: 10, pageIndex: 0 },
    visibleColumns: DefaultVisibleContactColumns,
};

const contact = createSlice({
    name: 'contact',
    initialState,
    reducers: {
        setContactListFilters(state, action) {
            state.filters = action.payload;
        },
        setContactListTournamentFilter(state, action) {
            state.tournamentFilter = action.payload;
        },
        setContactListSortingAndPagination(state, action) {
            state.sorting = action.payload.sorting;
            state.pagination = action.payload.pagination;
        },
        setContactColumnsPersistence(state, action) {
            state.visibleColumns = action.payload;
        },
    },
});

export default contact.reducer;

export const {
    setContactListFilters,
    setContactListTournamentFilter,
    setContactListSortingAndPagination,
    setContactColumnsPersistence,
} = contact.actions;
